<script>
    import { getContext } from 'svelte';
    const { errors } = getContext('form');
    export let message = null;
    export let fieldName;
    export let errorKey;
</script>
{#if $errors?.[fieldName]?.[errorKey]}
    <p class="text-red-500 text-xs mt-1">
        {message || $errors[fieldName][errorKey]}
    </p>
{/if}
